import * as React from "react";
import { AUTH_USER_STORAGE_KEY_NAME } from "utils/jwtUtils";

function subscribe(callback) {
  const storageHandler = (event) => {
    if (
      event.storageArea === window.localStorage &&
      event.key === AUTH_USER_STORAGE_KEY_NAME
    ) {
      callback();
    }
  };
  window.addEventListener("storage", storageHandler);
  return () => {
    window.removeEventListener("storage", storageHandler);
  };
}

function getSnapshot() {
  try {
    return window.localStorage.getItem(AUTH_USER_STORAGE_KEY_NAME);
  } catch {
    return null;
  }
}

function encode(value) {
  return value === null ? null : JSON.stringify(value);
}

function decode(value) {
  return value === null ? null : JSON.parse(value);
}

// Start with null for the hydration, and then switch to the actual value.
const getKeyServerSnapshot = () => null;

export function useLocalUserInfo(initializer) {
  const [initialValue] = React.useState(initializer);
  const encodedInitialValue = React.useMemo(
    () => encode(initialValue),
    [initialValue],
  );

  const subscribeKey = React.useCallback((callback) => subscribe(callback), []);

  const getKeySnapshot = React.useCallback(
    () => getSnapshot() ?? encodedInitialValue,
    [encodedInitialValue],
  );

  const encodedStoredValue = React.useSyncExternalStore(
    subscribeKey,
    getKeySnapshot,
    getKeyServerSnapshot,
  );

  const storedValue = React.useMemo(
    () => decode(encodedStoredValue),
    [encodedStoredValue],
  );

  return [storedValue];
}
